// Canonical Inventory Management operations (Id + Name), shared by the Operation dropdown
// on /im/InventoryOperation and the per-role Manage-Settings visibility toggles
// (security -> user-security -> Manage Settings -> Inventory Management).
export const INVENTORY_OPERATIONS = [
  { Id: 1, Name: "Mark For Sale" },
  { Id: 6, Name: "Mark Not For Sale" },
  { Id: 2, Name: "Add Inventory" },
  { Id: 3, Name: "Remove Dead" },
  { Id: 4, Name: "Move From Location" },
  { Id: 5, Name: "Move To Location" },
  { Id: 7, Name: "Quantity Shipped" },
];

// Role claim (AspNetRoleClaims) that stores the HIDDEN operation Ids as a comma-separated
// list. Empty / missing => every operation is visible (the default).
export const IM_HIDDEN_OPERATIONS_CLAIM = "IMHIDDENOPERATIONS";

// Parse the claim value ("3,5") into a numeric Id array.
export const parseHiddenOperationIds = (claimValue) =>
  String(claimValue || "")
    .split(",")
    .map((s) => parseInt(s, 10))
    .filter((n) => !Number.isNaN(n));

// True when the given operation Id is not in the hidden list.
export const isOperationVisible = (operationId, claimValue) =>
  !parseHiddenOperationIds(claimValue).includes(operationId);

// Filter an operations list (Id/Name or id/name shaped) down to the visible ones.
export const filterVisibleOperations = (operations, claimValue) => {
  const hidden = parseHiddenOperationIds(claimValue);
  if (hidden.length === 0) return operations || [];
  const hiddenSet = new Set(hidden);
  return (operations || []).filter((op) => !hiddenSet.has(op?.Id ?? op?.id));
};
